export const vaultTokenSymbol = "GEV";
